<script setup lang="ts">
import { EmployerRole, NullableRangeDto } from '@swipe4work/models-orval'
import CompanyContent from './components/CompanyContent.vue'

interface CompanyLocationEntity {
  id: number
  name: string
  geolocation: {
    latitude?: number
    longitude?: number
  }
}

definePage({
  path: 'bedrijf',
  name: '/onboarding/company',
  meta: {
    layout: 'false',
    allowedRoles: [ EmployerRole.CustomerOnboarding ],
  },
})

const companyFormStore = useCompanyFormStore()
const onboardingStore = useOnboardingStore()
const toast = useToast()

// fetch the payment options once the employer has an account, otherwise an error occurs
onboardingStore.fetchPaymentOptions()

const { t } = useI18n()

const employeeCountOptions = computed(() => companyFormStore.employeeCountOptions())

function handleInvalid() {
  toast.error(t('onboarding.company.error'))
}

function handleSubmit(companyEntity: {
  name: string
  location: CompanyLocationEntity
  employeeCount: NullableRangeDto
}) {
  onboardingStore.companyModel = {
    ...companyEntity,
    locationId: companyEntity.location.id,
  }

  onboardingStore.goToPage(2)
}
</script>

<template>
  <CompanyContent
    :employee-count-options="employeeCountOptions"
    @submit="handleSubmit"
    @invalid="handleInvalid"
  />
</template>
